// ABOUTME: Turns an occupied applicant identity into a field-level form error.
// ABOUTME: Uses the source metadata when deployed translations lag behind the code.
import editMetadata from "../../../../../server/src/scripts/start-data/MainData/METADATACOMPLEOMODULE-APPLICANTEDIT.json";

export const mapApplicantEditConflict = (
    response: any,
    translate: (key: string) => string,
    locale: string
) => {
    const httpResponse = response?.response ?? response;
    const field = httpResponse?.data?.field;
    if (
        httpResponse?.status !== 409 ||
        httpResponse?.data?.code !== "ApplicantDedupConflict" ||
        (field !== "email" && field !== "cpf")
    ) {
        return response;
    }

    const translationKey =
        field === "email"
            ? "identityEmailAlreadyUsed"
            : "identityCpfAlreadyUsed";
    const translated = translate(translationKey);
    const sourceLocale = locale.toLowerCase().startsWith("pt")
        ? "pt-BR"
        : "en-US";
    const message =
        translated && translated !== translationKey
            ? translated
            : editMetadata.Translation[sourceLocale][translationKey];

    return {
        status: 400,
        data: {
            message: [
                {
                    dataPath: `/${field}`,
                    message
                }
            ]
        }
    };
};
